function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 283.46 283.46"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M177.43 61.53a17.85 17.85 0 1 1-17.85-17.83 17.82 17.82 0 0 1 17.85 17.83m-47 5.94a29.76 29.76 0 0 0 58.3 0h30.36a5.95 5.95 0 1 0 0-11.89h-30.36a29.76 29.76 0 0 0-58.3 0H64.38a5.95 5.95 0 1 0 0 11.89Zm-12.5 53.47a17.85 17.85 0 1 1-17.85-17.83 17.84 17.84 0 0 1 17.85 17.83m-47 5.94a29.76 29.76 0 0 0 58.3 0h89.86a5.95 5.95 0 1 0 0-11.89h-89.86a29.76 29.76 0 0 0-58.3 0h-6.55a5.95 5.95 0 1 0 0 11.89Zm130.31 53.47a17.86 17.86 0 1 1-17.86-17.83 17.86 17.86 0 0 1 17.86 17.83m-47 5.94a29.76 29.76 0 0 0 58.29 0h6.56a5.95 5.95 0 1 0 0-11.89h-6.56a29.76 29.76 0 0 0-58.29 0H64.38a5.95 5.95 0 1 0 0 11.89Z",
    style: {
      fill: "#0054a6"
    }
  }));
};
export default SvgFilter;